import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { debounce } from '@mui/material/utils';
import { useSelector } from 'react-redux';
import { getState } from '../../redux/actions/actions';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'
import { ReportService } from '../../assets/_services/report-service';


interface CompanyInterface {
  label: string;
  value: number | string;
}

export default function FilterUser({setUserId} : any) {

  const authState = useSelector((state: any) => state.auth.authData);
  const user = getState(authState);

  const [value, setValue] = React.useState<CompanyInterface | null>(null);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState<CompanyInterface[]>([]);
  const [isLoadingSearch, setIsLoadingSearch] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const fetchData = () => {
      const formData = {}
      ReportService.searchUserByUserName(formData).then(
        response => {
          if(response.isSuccess){
            setOptions(response.data.data.map((item:any) => ({
              value : item?.userId, label : item?.userName
            })))
          }
        }
      )
  }

  const fetch = React.useMemo(
    () =>
      debounce(async (input: string) => {
        let formData = {
            companyName: input,
        };
        if (input.length > 3) {
            const response = await ReportService.searchUserByUserName(formData);
            if (response?.isSuccess) {
                let userData = response.data.data.map((item : any) => ({
                    value: item?.userId,
                    label: `${item.companyName} (${item.userName})`,
                }));
                setOptions(userData);
                setIsLoading(false)
            } else {
            setOptions([]);
            setIsLoading(false)
            }
        } else {
          setOptions([]);
          setIsLoading(false)
        }
      }, 500),
    []
  );

  React.useEffect(() => {
    if(user?.role !== '2'){
      setIsLoading(true)
      fetch(inputValue);
    }
  }, [inputValue]);

  React.useEffect(() => {
    if(user?.role === '2'){
      fetchData();
    }
  }, []);

  return (
    <>
      {
        user?.role === '2' ?
          <Autocomplete
            sx={{mt:1}}
            fullWidth
            options={options}
            autoComplete
            value={value}
            onChange={(event: any, newValue: CompanyInterface | null) => {
              setValue(newValue);
              setUserId(newValue?.value);
            }}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (<TextField {...params} label="Select User" fullWidth />)}
          />
         :
          <Autocomplete
            sx={{mt:1}}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            noOptionsText="No options"
            onChange={(event: any, newValue: CompanyInterface | null) => {
              // setOptions(newValue ? [newValue, ...options] : options);
              setValue(newValue);
              setUserId(newValue?.value);
            }}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField
              {...params}
              label="Search Company Name"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                  {inputValue.length > 3 ?
                      isLoading ? <CircularProgress size={20} /> : null
                  :   inputValue.length > 0 ? 
                          isLoadingSearch ?  <CircularProgress size={20} /> :
                          <Tooltip title="Search Company">
                          <IconButton
                              size='small'
                              color='primary'
                              onClick={()=>{
                                  setIsLoadingSearch(true)
                                  let formData = {
                                    companyName: inputValue,
                                  };
                                  ReportService.searchUserByUserName(formData).then(
                                      response => {
                                        if (response?.isSuccess) {
                                          let userData = response.data.data.map((item : any) => ({
                                              value: item?.userId,
                                              label: `${item.companyName} (${item.userName})`,
                                          }));
                                          setOptions(userData);
                                          setIsLoadingSearch(false)
                                      } else {
                                      setOptions([]);
                                      setIsLoadingSearch(false)
                                      }
                                      }
                                  )
                              }}
                              >
                                  {/* <ManageSearchIcon fontSize='medium' /> */}
                                  <SearchIcon fontSize='medium' />
                          </IconButton>
                          </Tooltip>
                      : null
                  }
                  {params.InputProps.endAdornment}
              </>
                ),
            }}
              />
            )}
          />
      }
    </>
  );
}
